import { Breadcrumb, HeaderToolbar } from "@xola/ui-kit";
import React from "react";
import { useHistory } from "react-router-dom";
import { ColumnLayout } from "../../components/Layout/ColumnLayout";
import { Analytics } from "../../components/Reports/Analytics/Analytics";
import { AnalyticsFilter } from "../../components/Reports/Analytics/AnalyticsFilter";
import { AnalyticsReportTable } from "../../components/Reports/Analytics/AnalyticsReportTable";
import { AnalyticsView, useAnalyticsFilterStore } from "../../stores/reports/analyticsFilterStore";
import { Page } from "../Page";

export const AnalyticsPage = () => {
    const history = useHistory();
    const view = useAnalyticsFilterStore((state) => state.filters.view);
    const handleClick = () => {
        history.push("/reports/analytics");
    };

    return (
        <Page title="Analytics">
            <ColumnLayout>
                <HeaderToolbar>
                    <HeaderToolbar.Breadcrumb className="truncate border-r-0">
                        <Breadcrumb.Item>Reports</Breadcrumb.Item>
                        <Breadcrumb.Item onClick={handleClick}>Analytics</Breadcrumb.Item>
                    </HeaderToolbar.Breadcrumb>
                </HeaderToolbar>
                <ColumnLayout.Fill>
                    <AnalyticsFilter />
                    {view === AnalyticsView.TABLE ? <AnalyticsReportTable /> : <Analytics />}
                </ColumnLayout.Fill>
            </ColumnLayout>
        </Page>
    );
};
